import React from "react";
import "../styles/About.css";
import AboutHeroSection from "../content/aboutData/aboutHeroSection/AboutHeroSection";
import OurVision from "../content/aboutData/ourMission/OurVision";
import WhyMakeUsDifferent from "../content/aboutData/whatMakesUsDifferent/WhyMakeUsDifferent";
import Mbrjourney from "../content/aboutData/mbrJourney/Mbrjourney";
import JoinOurMission from "../content/aboutData/joinOurMission/JoinOurMission";

function About() {
  return (
    <>
      {" "}
      <div className="about-container">
        <h2>About Us</h2>
        <p>
          CareerConnect is founded with a mission to bridge the gap between
          students and recruiters. We understand how challenging it can be for
          freshers to find the right job, so we guide, prepare, and connect them
          directly with hiring teams.
        </p>
        <p>
          Our focus is on degree and MBA students, helping them find jobs
          related to their fields while improving their confidence and
          communication.
        </p>
      </div>
      <AboutHeroSection />
      <OurVision />
      <WhyMakeUsDifferent />
      <Mbrjourney />
      <JoinOurMission />
    </>

  );
}

export default About;
